import React from "react";
import { Box, Card, List, Button } from "@mui/material";
import UserInvitationNotificationItem from "utils/Sidenav/UserInvitationNotificationItem";
import NotificationItem from "utils/Items/NotificationItem";
import { USER_INVITATION } from "lib/constants";

const NotificationsMenu = ({
  notifications,
  inviteLoading,
  handleDeclineInvite,
  handleAcceptInvite,
  handlePopoverClose,
  seenNotification,
  navigate,
  clearAllNotifications,
}) => (
  <Card
    sx={{
      borderRadius: 0,
      p: 1,
      position: "relative",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Button
        size="small"
        variant="text"
        onClick={() => {
          handlePopoverClose();
          clearAllNotifications();
        }}
        sx={{
          textTransform: "none",
          fontSize: "0.75rem",
          color: "primary.main",
        }}
      >
        Clear All
      </Button>
    </Box>
    <List>
      <Box id="notifications-menu-span-wrapper">
        {notifications.map((notification) =>
          notification.key.startsWith(USER_INVITATION) ? (
            <UserInvitationNotificationItem
              key={notification.key}
              title={notification.label}
              inviteCode={notification.href}
              isLoading={inviteLoading}
              handleDeclineInvitation={handleDeclineInvite}
              handleAcceptInvitation={handleAcceptInvite}
            />
          ) : (
            <NotificationItem
              key={notification.key}
              title={notification.label}
              onClick={() => {
                handlePopoverClose();
                if (notification?.id) seenNotification(notification.id);
                navigate(notification.href, { replace: true });
              }}
              displayClear
              onClear={() => {
                if (notification?.id) seenNotification(notification.id);
              }}
            />
          )
        )}
      </Box>
    </List>
  </Card>
);

export default NotificationsMenu;
